<template>
    <div id="archivo_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h4>LISTADOS DE ARCHIVO</h4>
            <h6>MODIFICACIÓN DE FECHA DE LISTADOS NO ENVIADOS</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 padding-div-low" >
                <div class="area">
                    <div class="form-group" id="AreasCatalogo">
                        <label>Área</label>
                        <CAreas
                            v-on:valorParaElPadre="cambioDeArea" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'catalogoAreas'" 
                            :parametros="BusquedaForm.parametros_Area" 
                            :valorDefinido="BusquedaForm.parametros_Area.areaId" 
                            :key="BusquedaForm.parametros_Area.areaId"
                            >
                        </CAreas>
                    </div>
                    <div class="form-group" id="Anio_div" v-if="BusquedaForm.parametros_Area.areaId>0">
                        <label>Fecha del Envío</label>
                        <input class="form-control" type="date" v-model="FechaEnvio"/>
                    </div>
                    <div class="form-group" v-if="BusquedaForm.parametros_Area.areaId>0">
                        <label>Tipo de Listado</label>
                            <select id="catalogoDeTipos" class="form-control" @change="cambiarTipo($event)">
                                <option value= 0>SELECCIONE LISTADO</option>
                                <option v-for="opcion in TipoListado" :key="opcion.TipoId" :value="opcion.TipoId" >{{opcion.Nombre}}</option>
                            </select>
                    </div>
                    <div id="VerificarFecha_div" class="form-group" v-if="BusquedaForm.parametros_Area.areaId>0 && parametros_Tipo.tipoId>0 && FechaEnvio!=null">
                            <button class="btn btn-sm btn-warning"  @click='VerificarFecha()'>Verificar Fecha de Listado</button>
                    </div>
                    <div class="form-group" id="fechaNueva_div" v-if="ListaArchivo.length>0 && NoEnviada">
                        <label class="text-success">Fecha Nueva</label>
                        <input class="form-control" type="date" v-model="FechaNueva"  />
                    </div>
                    <div id="cambiarFecha_div" class="form-group" v-if="ListaArchivo.length>0 && NoEnviada && FechaNueva!=null">
                            <button class="btn btn-sm btn-success"  @click='cambiarFecha(ListadoObtenido)'>Cambiar Fecha de Listado</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low" >
                <div class="area">
                    <div>
                        <h6>Listado de Archivo {{ListaArchivo.length>0 ? NombreArea : ''}}</h6>
                    </div>
                    <div>
                        <h6>Total : {{ListaArchivo.length}}</h6>
                    </div>
                    <div v-if="(ListaArchivo.length>0) && (NoEnviada==false)">
                        <h5 class="text-danger text-center">Listado enviado al archivo, no es posible modificar fecha de envío</h5>
                    </div>
                    <div>
                        <div id="ListaArchivo_table" class="table-responsive">
                            <table class="table table-light table-hover table-sm table-bordered">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Consecutivo</th>
                                        <th>Juicio</th>
                                        <th>Partes</th>
                                    </tr>
                                </thead>
                                <tbody class="text-dark">
                                    <tr v-if="ListaArchivo.length<=0" >
                                        <td colspan="12" class="text-center">Sin Documentos en Listado de Archivo</td>
                                    </tr>
                                    <tr v-else v-for="Lista in ListaArchivo" :key="Lista.InventarioDocumentoId">
                                        <td width ="100" v-html="TipoDocumentoHTML(Lista)"></td>
                                        <td width= "50">{{Lista.Consecutivo}}/{{Lista.Anio}}{{Lista.Sufijo!=null ? '-' + Lista.Sufijo: ''}}</td>
                                        <td width= "150" v-html="DesglosaTipoJuicio(Lista)"></td>
                                        <td width= "350" v-html="DesglosaPartes(Lista.Partes)"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas
    }, 
    data(){
        return {
            enumeraciones,
            BusquedaForm: {
                parametros_Area: {
                        areaId: -1,
                        conMaterias: true,
                        conOrdenamientoPorSistema: true,
                        Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                },
            },
            FechaEnvio: null,
            FechaNueva: null,
            ListaArchivo: [],
            ListadoObtenido: [],
            NoEnviada: false,
            TipoListado :[
                {TipoId: 1, Nombre: "NUEVO INGRESO"},
                {TipoId: 2, Nombre: "REINGRESO"}
            ],
            parametros_Tipo: {
                tipoId: 0
            },
            NombreArea:''
        }
    },
    methods:{
        cambioDeArea(datos){
            console.log(datos[0])
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.NombreArea = datos[0].target.selectedOptions[0].text
            if(this.BusquedaForm.parametros_Area.areaId==-1)
            {
                $('#navListaArchivo_table').remove();
                this.parametros_Tipo.tipoId = 0;
                this.FechaEnvio= null;
                this.FechaNueva= null;
                this.NoEnviada = false;
                this.ListaArchivo = [];
                this.ListadoObtenido = [];
                this.NombreArea="";
            }
        },
        VerificarFecha(){
            $('#navListaArchivo_table').remove();
            var AreaId = this.BusquedaForm.parametros_Area.areaId;
            var tipoEnvio = this.parametros_Tipo.tipoId==2 ? true : false;
            
            var peticion = {"AreaId": AreaId, "FechaEnvio": this.FechaEnvio, "Devueltos" : tipoEnvio};
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.VerificarFechaListado, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                else
                    {   
                        comun.SeEstaCargandoInformacion(false);
                        this.ListadoObtenido = respuesta.data.ListadosArchivo!=null ? respuesta.data.ListadosArchivo :[];
                        
                        var NoEnviadosConteo = this.ListadoObtenido.filter(a=>a.Enviado==false);
                        var FormatoLista = [];
                        $.each(this.ListadoObtenido, function(index, lista)
                            {
                                lista.InventarioDocumentos.Enviado = lista.Enviado;
                                FormatoLista.push(lista.InventarioDocumentos);
                        })
                        this.ListaArchivo = FormatoLista.sort(this.sortAnioConsecutivo);

                        this.$nextTick(()=> { PaginarTabla('ListaArchivo_table', 10)});
                        if(this.ListaArchivo.length==NoEnviadosConteo.length)
                        {
                            this.NoEnviada=true
                        }
                        else
                        {
                            this.NoEnviada=false
                        }
                        if(this.ListadoObtenido.length==0)
                        {
                            comun.mensajeDeAlerta("No se encontro listado", null, null);
                        }
                        console.log(this.ListaArchivo)
                    }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });

            
        },
        TipoDocumentoHTML(tipo) {
            let TipoDocumento = ''
            switch(tipo.TipoDocumento.TipoDocumentoId)
            {
                case 1: 
                if(tipo.Materia.MateriaId==6)
                {
                    TipoDocumento = "EXPEDIENTE PENAL";
                }
                else
                {
                    TipoDocumento = "EXPEDIENTE PRINCIPAL";
                }
                break;
                case 2: 
                TipoDocumento = "TERCERÍA";
                break;
                case 4:
                    if(tipo.Materia.MateriaId==6 || tipo.Materia.MateriaId==9)
                    {
                        TipoDocumento = "AMPARO PENAL";
                    }
                    else
                    {
                        TipoDocumento = "CUADERNO DE AMPARO";
                    }
                    break;
                case 5:
                    if(tipo.Materia.MateriaId==6 || tipo.Materia.MateriaId==9)
                    {
                        TipoDocumento = "EXHORTO PENAL";
                    }
                    else
                    {
                        TipoDocumento = "EXHORTO";
                    } 
                    break;
                case 6: 
                    TipoDocumento = "REQUISITORIA";
                    break;
                case 10: 
                    TipoDocumento = "INCIDENTE";
                    break;
                case 11: 
                    TipoDocumento = "ROGATORIA";
                    break;
                case 12: 
                    TipoDocumento = "DESPACHO";
                    break;
                case 16:
                    if(tipo.Materia.MateriaId==6 || tipo.Materia.MateriaId==9)
                    {
                        TipoDocumento = "TOCA PENAL";
                    }
                    else
                    {
                        TipoDocumento = "TOCA CIVIL";
                    }
                    break;
                case 23:
                    TipoDocumento="CARPETA DIGITAL";
                    break;
                case 24:
                    TipoDocumento="CARPETA ADMINISTRATIVA";
                    break;
                case 26:
                    TipoDocumento="CARPETA DE EJECUCIÓM";
                    break;
                case 27:
                    TipoDocumento="CARPETA DE JUICIO";
                    break;
            };
            return TipoDocumento;
        },
        DesglosaTipoJuicio: function(datos){
            var Juicio = "";
            if(datos.Materia.MateriaId!=9)
            {
                if(datos.Juicio!=null && (datos.Juicio.Juicio!=null && datos.Juicio.Juicio!=""))
                {
                    Juicio = datos.Juicio.Juicio + "</br>" + "TIPO: " + datos.Juicio.Tramite;
                }
            }
            return Juicio;
        },
        DesglosaPartes: function(datos) {
            var Partes ="";
            if(datos!=null && datos.length>0)
            {
                $.each(datos, function(index, parte)
                {
                    Partes = Partes + parte.Tipo_Parte + " : " + parte.Nombre + " " + 
                    (parte.ApellidoPaterno!=null?parte.ApellidoPaterno : "") + " " + (parte.ApellidoMaterno!=null ? parte.ApellidoMaterno : "" ) + "</br>"
                })
                
            }
            return Partes;
        },
        sortAnioConsecutivo: function (a,b)
        {
            if(a.TipoDocumento.TipoDocumentoId < b.TipoDocumento.TipoDocumentoId) return -1
            if(a.TipoDocumento.TipoDocumentoId > b.TipoDocumento.TipoDocumentoId) return 1
            if(a.Anio < b.Anio) return -1
            if(a.Anio > b.Anio) return 1
            if(a.Consecutivo < b.Consecutivo) return -1
            if(a.Consecutivo > b.Consecutivo) return 1
            return 0
        },
        cambiarTipo(datos){
            this.parametros_Tipo.tipoId = parseInt(datos.target.value);
        },
        cambiarFecha(datos){
            var fechaModificada = moment(this.FechaNueva).format('YYYY-MM-DD 00:00:00')
            $.each(datos, function(id, lista)
            {
                lista.FechaEnvio = fechaModificada;
            });
            let peticion = {"ListadoArchivo": datos};
            comun.SeEstaCargandoInformacion(true);
           
            axios.post(api.conexion + api.ArchivoJudicial.CambiaFechaListado, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                else
                    {   
                        comun.SeEstaCargandoInformacion(false);
                        this.ListaArchivo = [];
                        this.ListadoObtenido = [];
                        this.BusquedaForm.parametros_Area.areaId=-1;
                        this.parametros_Tipo.tipoId = 0;
                        this.FechaEnvio= "";
                        this.FechaNueva= "";
                        this.NoEnviada = false;
                        $('#navListaArchivo_table').remove();
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                comun.SeEstaCargandoInformacion(false);
            })
            .catch(excepcion => {
                console.log(excepcion);
                console.log("fallo por parametros");
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);
            });
        }
    }
}

</script>
    


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Movimientos/CambioFechaListados.vue